import { Expose } from "class-transformer";
import { Model } from "./model";

export class EducationPathPreference extends Model{
  @Expose() initiationPercentage : number;
  @Expose() readAndEjazaPercentage : number;
  @Expose() recitationPercentage : number;
  @Expose() recitePercentage : number;
}
